export default "__VITE_ASSET__wuNc25mn__"